import { FSA } from 'flux-standard-action';

export enum dynamicTitlesActionTypes {
  add = '@dynamic-titles/ADD',
  clear = '@dynamic-titles/CLEAR',
  remove = '@dynamic-titles/REMOVE',
}

export enum dynamicTitlesKey {
  page = 'page',
  dashboard = 'dashboard'
}

export interface DynamicTitlesPayload {
  key: dynamicTitlesKey;
  value?: string;
}

export interface DynamicTitles {
  add: (payload: DynamicTitlesPayload) => FSA<dynamicTitlesActionTypes.add, DynamicTitlesPayload>;
  clear: () => FSA<dynamicTitlesActionTypes.clear, undefined>;
  remove: (payload: DynamicTitlesPayload) => FSA<dynamicTitlesActionTypes.remove, DynamicTitlesPayload>;
}

const add = (payload: DynamicTitlesPayload): FSA<dynamicTitlesActionTypes.add, DynamicTitlesPayload> => ({
  type: dynamicTitlesActionTypes.add,
  payload,
});

const clear = (): FSA<dynamicTitlesActionTypes.clear, undefined> => ({
  type: dynamicTitlesActionTypes.clear
});

const remove = (payload: DynamicTitlesPayload): FSA<dynamicTitlesActionTypes.remove, DynamicTitlesPayload> => ({
  type: dynamicTitlesActionTypes.remove,
  payload,
});

export const dynamicTitles: DynamicTitles = {
  add,
  clear,
  remove
};